module.exports = __webpack_public_path__ + "static/media/sales-title-back.3648501f.svg";